var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dashboard-wrapper"},[_c('navbar',{attrs:{"user-type":"instructor"}}),_c('router-view',{staticClass:"router"}),_c('base-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }